import React,{useState} from 'react';
import DatePicker,{registerLocale} from "react-datepicker";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ko from "date-fns/locale/ko";
import axios from 'axios';
import './styles/App.css';
import M_Footer from './M_Footer';
import TopTitle from './TopTitle';
import {formatDate,phoneFormat, Select,instance} from './common';
import CircleX from './img/bi_x-circle.png';
import {Link} from 'react-router-dom';
import queryString from 'query-string';

registerLocale("ko", ko)

//차량등록 모달창

function Example(props) {
  // 검색 state 관리
  const [obj, setObj] = useState({
      value:'car_brand',
      keyword:'',
  });

  const onChange = (e) => {
      const {name,value} = e.target;
      
      setObj({
          ...obj,
          [name]:value
      })
      
  }

  const { buttonLabel, className} = props;

  const [modal, setModal] = useState(false);

  const toggle = () => {
      setModal(!modal);
      if(!modal){
          loadCar(obj);
      }
  }
  
  const search = () => {
      loadCar(obj);
  }

  const select = () => {
      const target = document.querySelector('.tr-line.active');
      if(target !==null){
          console.log('target : ', target.dataset.name);
          document.getElementsByName('u_car_name')[1].value = target.dataset.name;
          setModal(!modal);
      }else{
          alert("차량을 선택해주세요.");
      }
  }


  return (
      <>
      <span className="jungbok" onClick={toggle}>{buttonLabel}</span>

      <Modal isOpen={modal} toggle={toggle} className={className}>
          <ModalHeader toggle={toggle}>{buttonLabel}</ModalHeader>
          <ModalBody>
              <InputGroup onChange={onChange} search={search} />
              <Table />
          </ModalBody>
          <ModalFooter>
              <Button color="primary" onClick={select}>선택</Button>
              <Button color="secondary" onClick={toggle}>닫기</Button>
          </ModalFooter>
      </Modal>
      </>
  );
}

function InputGroup({onChange,search}){

  
  return (
      <div className="mb-2">
          <select name="value" className="form-control d-inline-block w-25 mr-2" onChange={onChange}>
              <option value="car_brand">브랜드</option>
              <option value="car_name">차명</option>
          </select>
          <input name="keyword" type="text" autoComplete="off" className="form-control d-inline-block w-50 mr-2"  onChange={onChange}/>
          <span className="btn btn-primary" onClick={search}>검색</span>
      </div>
  );
}

function Table(){
  // th 배열
  const thArray = [
      '브랜드',
      '차명'
  ];
  
  return (
      <table className="table table-bordered text-center">
          <thead>
              <tr>
                  {thArray.map((v,i) => (<th key={i}>{v}</th>))}
              </tr>
          </thead>
          <tbody id="item-tbody">
          </tbody>
      </table>
  )
}


function loadCar(obj){
  console.log('obj : ', obj);
  instance.post('/car/all',{
      obj:obj
  })
  .then(function (response) {
      // handle success
      const data = response.data;
      console.log('data : ', data);
      document.getElementById('item-tbody').innerHTML = '';
      if(data.length !==0){
          let str = '';
          data.forEach(v => {
              str += '<tr class="tr-line" data-name="'+v.car_name+'">\
                  <td>'+v.car_brand+'</td>\
                  <td>'+v.car_name+'</td>\
              </tr>';
              
          });
          document.getElementById('item-tbody').innerHTML = str;

          const lines = document.querySelectorAll('.tr-line');
          for(const line of lines){
              line.addEventListener('click', function() {
                  if(document.querySelector('.tr-line.active') !==null){
                      document.querySelector('.tr-line.active').classList.remove('active');
                  }
                  this.classList.add('active');
              })
              
              
          }
      }    
      
  })
  .catch(function (error) {
      // handle error
      console.log(error);
  })
}

function Year({onChange}){
  let today = new Date();
  let year = today.getFullYear();
  let yearArr = [];
  for(let i=1940;i<=year;i++){
      yearArr.push(i)
      
  }
  yearArr = yearArr.reverse();

  return (
      <Select name="u_car_age" onChange={onChange} optionArr={yearArr}/>
  )
  
}

function Color({onChange}){
  let optionArr = ['화이트','블랙','그레이','실버'];

  return (
      <Select name="u_car_color" onChange={onChange} optionArr={optionArr}/>
  )
  
}

//상단 자동차 그려주는 컴포넌트
function InfoCarGrid({onClick}){
    return (
        <div className="row car_info_Area" onClick={onClick}>
            <div className="car_info_inArea">
            <span className="font-weight-bold CM_big_name">테슬라 Model Y <span className="CM_small_name ml-2">대표</span></span>
            <div className="CircleX_img"><img className="CircleX_img" src={CircleX}></img></div>
            <div className="car_info_carnum mb-3">123가 4568</div>
            <div className="col-6 pl-0 d-inline-block car_info_list">
                <span>년식</span><br></br>
                <span>출고일</span><br></br>
                <span>차량 APP 등록일</span><br></br>
                <span>출고 색상</span><br></br>
            </div>
            <div className="col-6  d-inline-block car_info_list2">
                <span>2020</span><br></br>
                <span>2020-01-01</span><br></br>
                <span>2020-02-05</span><br></br>
                <span><strong>블랙</strong></span><br></br>
            </div>
            </div>
        </div>
    )
}

function CarManagement({history, location, match}) {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const borderNone = {border: '0'}
  const marginCss = {marginTop:'23px'}

  const [inputs, setInputs] = useState({
    u_car_number:'',
    u_car_age:'',
    u_car_color:'',
    u_car_date:'',
});

const goBack = () => {
    history.goBack();
};
    
    
const query = queryString.parse(location.search);
    let cate = query.cate;
    console.log('cate ???? ', cate);

    const onClick = () => {
        history.push('/driverinform?cate='+cate);
        
    }

const {u_car_number,u_car_age,u_car_color,u_car_date} =inputs;

  const onChange = (e) => {
    let {name,value} = e.target;
    
    setInputs({
        ...inputs,
        [name]:value
    })

}
const marginStyle = {
    marginBottom : "100px",

}
    
  return (
      <>
      <div className="container"  style={marginStyle}>
          <TopTitle title="자동차 정보 관리"/>
            <InfoCarGrid onClick={onClick} />

            <div className="text-center text-color mt-5 mb-5 font-weight-bold">대표차량 설정</div>
            <div className="text-left col-12">
                <h3 className="font-weight-bold mb-5 mt-3">차량 추가</h3>
            </div>
         {/* */}
         <div className="container mt-4">
          <div className="id mb-4">
                <div className="input text-left">차량등록</div>
                <div>
                    <input name="u_car_name" className="userId" type="text" readOnly />
                    <Example buttonLabel="차량검색" className="car-search" />
                </div>
            </div>
            <div className="id mb-4">
                <div className="input text-left">차량번호</div>
                <div>
                    <input name="u_car_number" className="userId" type="text" value={u_car_number} />
                </div>
            </div>
            <div className="id mb-4" style={borderNone}>
                <div className="input text-left">차량연식</div>
                <div style={marginCss}>
                    <Year onChange={onChange}/>
                </div>
            </div>
            <div className="id mb-4" style={borderNone}>
                <div className="input text-left">차량색깔</div>
                <div style={marginCss}>
                    <Color onChange={onChange}/>
                </div>
            </div>
            <div className="id mb-5" style={borderNone}>
                <div className="input text-left">차량 출고일</div>
                <div style={marginCss}>
                    <DatePicker
                        locale="ko"
                        dateFormat="yyyy-MM-dd"
                        className="form-control" 
                        selected={startDate} 
                        onChange={date => setStartDate(date)}
                    />
                </div>
            </div>
            <div className="loginbtn">
                <button type="button" className="btn btn-primary w-100 pt-3 pb-3">추가하기</button>    
            </div>
            <div>
                <span className="btn btn-primary r_btnsize mt-3" onClick={goBack}>뒤로가기</span>
            </div>
         </div>
      

      </div>
      <M_Footer />
      </>
      

  );
}

export default CarManagement;